import React, { useEffect, useState } from "react";
import SearchAndSelect from "../../../components/generic/search/SearchAndSelect";
import { mapIntentToRequest } from "../../../service/network/RequestMapper";
import { getApiUrl } from "../../../service/network/UrlMapper";
import { performPostRequest } from "../../../service/network/NetworkService";
import IntentType from "../../../intentexecutor/utils/IntentType";
import { useGetOrgIdentifier } from "../../generic/hooks/useGetOrgIdentifier";
import { useRecoilState } from "recoil";
import { careplanStatusRecoil } from "../../../components/recoil/careplanStatusRecoil";

const SelectCarePlanStatus = () => {
  const organizationIdentifier = useGetOrgIdentifier();
  const [carePlanStatus, setCarePlanStatus] =
    useRecoilState(careplanStatusRecoil);
  const [statusList, setStatusList] = useState([]);

  useEffect(() => {
    const fetchSourceList = async () => {
      const payload = {
        configurationKey: ["niramaya.volunteer.request.filter.options"],
      };
      const request = mapIntentToRequest(
        IntentType.GET_CONFIGURATION,
        payload,
        {
          organizationIdentifier: organizationIdentifier,
        },
      );
      const urlMapper = getApiUrl();
      const result = await performPostRequest(
        urlMapper[IntentType.GET_CONFIGURATION],
        JSON.stringify(request),
      );
      const response = await result.json();
      const parsedResult =
        response[0].configurationValue &&
        JSON.parse(response[0].configurationValue);

      setStatusList(parsedResult);
    };

    fetchSourceList();
  }, [organizationIdentifier]);

  return (
    <>
      <div className="careplan-select-wrapper">
        <SearchAndSelect
          mode="multiple"
          selectedValues={carePlanStatus}
          placeholder="Click here to select status"
          setValue={setCarePlanStatus}
          style={{
            width: "100%",
          }}
          options={statusList}
          selectOptionType="Simple"
          noDebounceSearch={true}
        />
      </div>
    </>
  );
};

export default SelectCarePlanStatus;
